import { cEl } from '../../../../../util';
import forks from '../../../../../assets/images/forks.svg';
import ban from '../../../../../assets/images/ban.svg';
import thumbsUp from '../../../../../assets/images/thumbs-up.svg';

function EnvironmentSlide() {
    const environmentSlide = cEl('article');
    environmentSlide.classList.add('carousel-slide', 'environment-slide');
    environmentSlide.innerHTML = `
    <h2>로봇 활용을 위한 병원 환경</h2>
    <div class="slide-item-list">
        <div class="slide-item">
            <div class="img-container">
                <img src="${forks}" alt="forks" />    
            </div>
            <div>
                <div class="sub-topic">로봇 운행 제한 동선 및 엘리베이터 대기 시간</div>
                계단, 수동문, 가파른 경사, 구형 엘리베이터 등은 로봇 운행에 장애가 될 수 있으며, 다수의 로봇이 운영될 경우에는 <span class="text-highlight">엘리베이터 혼잡도를 예상하여 로봇 운행 가능성과 시간 등을 고려</span>해야합니다        
            </div>
        </div>
        <div class="slide-item">
            <div class="img-container">
                <img src="${ban}" alt="ban area" />
            </div>
            <div>
                <div class="sub-topic">응급 구역 제외</div>
                응급 환자 동선과 중환자 구역은 로봇 운행을 피하세요.<br>
                의료진의 원활한 응급 대응을 위해 <span class="text-highlight">동선을 신중히 선택</span>해야 합니다.        
            </div>
        </div>
        <div class="slide-item">
            <div class="img-container">
                <img src="${thumbsUp}" alt="thumbs-up" />
            </div>
            <div>
                <div class="sub-topic">병원의 규정 및 인증 준수</div>
                투약 오류 방지, 안전한 검체 이송 등 <span class="text-highlight">병원 규정과 인증을 준수하고, 필요 시 규정 변경을 준비</span>하세요.        
            </div>
        </div>
    </div>
    `;
    return environmentSlide;
}

export default EnvironmentSlide;
